import angular from 'angular';
import uiRouter from 'angular-ui-router';
import premiumComponent from './premium.component';
import premiumFactory from './premium.factory';

const premiumModule = angular
  .module('premium', [uiRouter])
  .component('premium', premiumComponent)
  .factory('Premium', premiumFactory)
  .config(($stateProvider) => {
    'ngInject';

    $stateProvider.state('main.premium', {
      url: '/premium',
      component: 'premium',
    });
  }).name;

export default premiumModule;



// WEBPACK FOOTER //
// ./client/app/components/premium/premium.js